import { useQuery } from '@tanstack/react-query'
import { fetchEntitlement } from '@/api/billing'
import { useCurrentHousehold } from '@/hooks/useCurrentHousehold'

/** Billing entitlement for the active household — drives the trial-ended read-only mode and trial banners. */
export function useEntitlement() {
  const { householdId } = useCurrentHousehold()
  return useQuery({
    queryKey: ['entitlement', householdId],
    queryFn: fetchEntitlement,
    enabled: !!householdId,
    staleTime: 60_000,
  })
}
